import React, { useState, useRef, useEffect } from 'react';
import { Grid, Typography, Button, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import {
  TableComponents,
  ExportButton,
  LoadingPage,
  FilterPod,
  ButtonLoading,
  SimpleDialog,
  TransactionReceiptDg,
  ConfirmDialog as WargignSpaceSize,
  PriceLabel,
} from 'components';
import { enifyDateTime, getDynamicObjectAction } from 'utility';
import { useQuery, useExportFile, useCopy, useCurrencyUnit } from 'hooks';
import { toFilterVOS } from 'components/FilterPod';
import { columns } from './Columns';
import SubsetServices from '../../../services/SubsetServices';
import generateData from './generateData';
import InitFilters from '../constants/InitFiltering';
import UploadDialog from '../components/UploadDialog';
import TagingDialog from '../components/TagingDialog';
import jMoment from 'moment-jalaali';
import { ReportOfflineTransactionActions, ExportPodSpaceDg, TimelineDg } from 'components';
import ShareSerives from 'utility/ShareServices';
import FilterButton from 'components/FilterPod/FilterButton';
import axios from 'axios';

const Content = ({ dataBusiness, dateServer }) => {
  const query = useQuery();
  const isImprest = query?.get('imprest') === 'true';
  // -- STATES --//
  const [filters, setFilters] = useState(InitFilters());
  const [loading, setLoading] = useState(true);
  const [filterParams, setFilterParams] = useState(null);
  const [isOpenTagDialog, setIsOpenTagDialog] = useState(false);
  const [isOpenUploadDialog, setIsOpenUploadDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [loadingPage, setLoadingPage] = useState(true);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [isShowExport, setIsShowEport] = useState(false);
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isOpenShowExportDG, setIsOpenShowExportDG] = useState(false);
  const [fGuild, setFGuild] = useState(isImprest ? 'true' : null);
  const [isOpenTransactionReceipt, setIsOpenTransactionReceipt] = useState(false);
  const [timeLineLength, setTimeLineLength] = useState(0);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  //====================================================================================
  const currencyText = useCurrencyUnit(false);

  const [statistics, setStatistics] = useState({
    totalInventory: 0,
    totalDeposit: 0,
    creditAmount: 0,
    lastCredit: 0,
    totalCredit: 0,
  });

  const [isLoadingExportOffline, setIsLoadingExportOffline] = useState(false);
  const [isOpenTimeLineDg, setIsOpenTimeLineDg] = useState(false);
  const [actionItemsBranch, setActionItemsBranch] = useState([
    {
      title: 'دریافت خروجی فرمت بانکی با پسوند xls',
      type: 'xls',
      status: '',
    },
    {
      title: 'دریافت خروجی فرمت بانکی با پسوند csv',
      type: 'csv',
      status: '',
    },
  ]);
  const [actionItemsImprest, setActionItemsImprest] = useState([
    {
      title: 'دریافت خروجی فرمت بانکی با پسوند xls',
      type: 'xls',
      status: '',
    },
    {
      title: 'دریافت خروجی فرمت بانکی با پسوند csv',
      type: 'csv',
      status: '',
    },
    {
      title: 'درخواست خروجی فرمت بانکی با پسوند pdf',
      type: 'Pdf',
      status: 'offline',
    },
  ]);

  /**
   * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
   */
  const actionsList = isImprest
    ? getDynamicObjectAction([
        'imprestTransactionBillDocumentAction',
        'imprestTransactionBillTagAction',
        'imprestTransactionBillAction',
        'imprestTransactionBillExportBtn',
        'imprestListReportExport',
        'imprestListReportTransactionRead',
        'imprestListReportTransactionDocument',
        'imprestListReportTransactionTags',
      ])
    : getDynamicObjectAction([
        'branchTransactionBillDocumentAction',
        'branchTransactionBillTagAction',
        'branchTransactionBillAction',
        'branchTransactionBillExportBtn',
      ]);
  // -- HOOKS --//
  const classes = useStyle();
  const { copyItem } = useCopy();
  const tableRef = useRef();

  const navigate = useNavigate();

  const { downloadFile, isExporting } = useExportFile({
    url: `/report/bills/${dataBusiness?.userId}/accountBillForOther/export`,
    filename: `${dataBusiness?.name || 'bills'}`,
  });

  useEffect(() => {
    const tempFilters = [...filters];
    const dateRangeIndex = tempFilters.findIndex((f) => f?.keyName === 'dateRange');
    if (dateRangeIndex == 0 && dateServer.start && dateServer.end) {
      // اگر فیلترهای تاریخ از سمت بک اند دیتا داشته باشد عملیات بارگذاری تاریخ پیشفرض در سرویس انجام خواهد شد
      tempFilters[dateRangeIndex] = {
        ...tempFilters[dateRangeIndex],
        value: {
          start: jMoment(new Date(dateServer.start).setHours(0, 0, 0, 0)),
          end: jMoment(new Date(dateServer.end).setHours(23, 59, 0, 0)),
        },
        filterProps: {
          ...tempFilters[dateRangeIndex]?.filterProps,
        },
      };
      onFiltersChange([...tempFilters]);
    }
    setLoadingPage(false);
  }, []);

  const getList = async (query) => {
    try {
      setLoading(true);

      const orderBy = [];
      const newFilters = [...filters];

      const filter = toFilterVOS([...newFilters]);
      const params = {
        page: query ? query?.pageNumber : page,
        size: query?.pageSize || size,
        businessId: dataBusiness?.id || null,
        dateFrom: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
        dateTo: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
        userId: dataBusiness?.userId || null,
        wallet: 'PODLAND_WALLET',
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });
      const res = await SubsetServices.getBranchTransction(dataBusiness?.userId, params, data);
      let list = [];
      if (fGuild && fGuild.toString() == 'true') {
        // اگر صورتحساب mprest باشد لیست ریپورت آفلاین را از سرور درخواست میدهد
        reportOffileRequest();
      }
      if (res?.data?.result?.rows.length > 0) {
        list = generateData(res?.data?.result?.rows, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      if (res?.data?.result?.rows?.length > 0) {
        const totalInventory = 0;
        let totalCredit = 0;
        let totalDeposit = 0;
        const lastCredit = list?.[0]?.accountBalance;
        list.forEach((l) => {
          totalDeposit += +l.priceDeposit;
          totalCredit += +l.priceWithdraw;
        });

        setStatistics((state) => ({
          ...state,
          totalInventory,
          totalDeposit,
          totalCredit,
          lastCredit,
        }));
      }

      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.data?.result?.totalCount,
      };
      return d;
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        let d = {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
        return d;
      }
    }
  };
  /**
   * کمبوباکس دریافت فایل خروجی هرکدام که انتخاب شود این تابع کال میشود
   */
  const onExport = (data) => {
    if (data.status == '') {
      // خروجی معمولی
      downloadFile(data.type, filterParams?.data, filterParams?.params);
    } else {
      onRequestExportPDF();
    }
  };
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };
  const openUploadDialog = (row) => {
    setSelectedRow(row);
    setIsOpenUploadDialog(true);
  };
  const onShowExportUrl = () => {
    setIsShowEport(true);
    SubsetServices.getAddressExportFile()
      .then((res) => {
        setIsShowEport(false);
        setIsOpenShowExportDG(false);
        setTimeout(() => {
          window.open(res?.result);
        }, 100);
      })
      .catch((error) => {
        setIsShowEport(false);
      });
  };

  /**
   * گزارش آفلاین
   */
  const onRequestExportPDF = () => {
    setIsLoadingExportOffline(true);
    const obj = {
      businessId: filterParams.params.businessId,
      dateFrom: filterParams.params.dateFrom,
      dateTo: filterParams.params.dateTo,
      userId: filterParams.params.userId,
      wallet: filterParams.params.wallet,
    };
    SubsetServices.reportPdf(filterParams.data, obj, dataBusiness?.userId)
      .then((res) => {
        setIsLoadingExportOffline(false);

        setIsOpenExportDG(true);
        setIsLoadingExport(false);
        reportOffileRequest();
      })
      .catch((error) => {
        setIsLoadingExport(false);
        setIsLoadingExportOffline(false);
      });
  };
  const onOpenTagDg = (row) => {
    setSelectedRow(row);
    setIsOpenTagDialog(true);
  };
  /**
   * از قسمت عملیات گزینه رسید تراکنش کلیک میشود و این رویداد اتفاق میفتد
   */
  const onOpenRecieptTranaction = (rowData) => {
    setSelectedRow(rowData);
    setIsOpenTransactionReceipt(true);
  };
  /**
   * کلیک بر روی دکمه لیست درخواست گزارشات در کامپوونت ReportOfflineTransactionActions
   */
  const onclickListReports = () => {
    navigate(
      `/ReportOfflineTransactions?source=${
        isImprest ? 'imprestTransactionsWithId' : 'BranchTransactionsWithId'
      }`,
    );
  };
  const onExportBranch = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const reportOffileRequest = () => {
    if (actionsList['imprestTransactionBillExportBtn'] || actionsList['imprestListReportExport']) {
      // از صفحه لیست تنخواه گردان به این صفحه اومده باشه و به دکمه خروجی دسترسی داشته باشد
      const obj = {
        reportStatusKeys: ['TO_DO', 'DOING'],
        reportKeys: `IMPREST_TRANSACTIONS`,
      };
      ShareSerives.getRportOfflineRequest(obj)
        .then((res) => {
          setTimeLineLength(res?.count || 0);
        })
        .catch((error) => {});
    }
  };

  useEffect(() => {
    !isOpenTimeLineDg && reportOffileRequest();
  }, [isOpenTimeLineDg]);
  return (
    <>
      {loadingPage ? (
        <LoadingPage />
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="flex-end"
              style={{ marginBottom: 16 }}
            >
              <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
              {fGuild && fGuild.toString().trim() == 'true'
                ? isImprest &&
                  (actionsList['imprestTransactionBillExportBtn'] ||
                    actionsList['imprestListReportExport']) && (
                    <ReportOfflineTransactionActions
                      menuList={
                        fGuild && fGuild.toString() == 'true'
                          ? actionItemsImprest
                          : actionItemsBranch
                      }
                      onExport={onExport}
                      loading={isExporting || isLoadingExport || isLoadingExportOffline}
                      onclickListReports={onclickListReports}
                      setIsOpenTimeLineDg={setIsOpenTimeLineDg}
                      timeLineLength={timeLineLength}
                    />
                  )
                : !isImprest &&
                  actionsList['branchTransactionBillExportBtn'] && (
                    <Grid>
                      <ExportButton
                        loading={isExporting}
                        types={['xls', 'csv']}
                        onExport={onExportBranch}
                      />
                    </Grid>
                  )}
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <TableComponents
              data={getList}
              columns={columns(
                copyItem,
                openUploadDialog,
                onOpenTagDg,
                onOpenRecieptTranaction,
                classes,
                actionsList,
                fGuild,
              )}
              isLoading={loading}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getList(ps);
              }}
            />
            <Grid>
              <Typography style={{ marginTop: '1em' }}>
                مجموع واریز:‌{' '}
                <PriceLabel amount={statistics.totalDeposit} currency={currencyText} />
              </Typography>
              <Typography style={{ marginTop: '1em' }}>
                مجموع برداشت: <PriceLabel amount={statistics.totalCredit} currency={currencyText} />
              </Typography>
              <Typography style={{ marginTop: '1em' }}>
                مانده: <PriceLabel amount={statistics.lastCredit} currency={currencyText} />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      <UploadDialog
        open={isOpenUploadDialog}
        setOpen={setIsOpenUploadDialog}
        row={selectedRow}
        tableRef={tableRef}
        userId={dataBusiness?.userId}
      />
      <SimpleDialog fullWidth maxWidth="sm" open={isOpenShowExportDG} title="مشاهده فایل خروجی">
        <Grid container style={{ textAlign: 'justify' }}>
          برای مشاهده فایل، حداقل یک ساعت بعد از درخواست فایل خروجی به اکانت پاد اسپیس خود مراجعه
          فرمایید.
        </Grid>
        <Grid
          style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '16px', gap: '15px' }}
        >
          <ButtonLoading
            variant="contained"
            color="primary"
            onClick={onShowExportUrl}
            loading={isShowExport}
            disabled={isShowExport}
            name="پاد اسپیس"
          />

          <Button
            variant="contained"
            onClick={() => setIsOpenShowExportDG(false)}
            style={{ marginRight: '8px' }}
          >
            بستن
          </Button>
        </Grid>
      </SimpleDialog>
      <TagingDialog
        open={isOpenTagDialog}
        setOpen={setIsOpenTagDialog}
        row={selectedRow}
        tableRef={tableRef}
        tags={[]}
      />
      <TransactionReceiptDg
        userId={dataBusiness?.userId}
        documentItemId={selectedRow?.documentItemId}
        documentId={selectedRow?.docId}
        isOpenTransactionReceipt={isOpenTransactionReceipt}
        setIsOpenTransactionReceipt={setIsOpenTransactionReceipt}
      />
      <ExportPodSpaceDg isOpenExportDG={isOpenExportDG} setIsOpenExportDG={setIsOpenExportDG} />
      <TimelineDg
        isOpenTimetDG={isOpenTimeLineDg}
        setIsOpenTimetDG={setIsOpenTimeLineDg}
        reportKey="IMPREST_TRANSACTIONS"
      />
    </>
  );
};

const useStyle = makeStyles((theme) => ({
  copyIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: theme.spacing(1),
    marginTop: -2,
  },
}));

export default Content;
